import {
	ADD_TO_FAVOURITE,
	GET_SEARCH_RESULT,
	IS_EDIT_PRESENTATION,
	IS_FOCUS_ON_MODAL_CLOSE,
	IS_TECHPACK_OPEN,
	REMOVE_SEARCH_RESULT,
	SELECTED_SEARCH_TYPE,
	UPDATE_SAMPLE_ID,
	UPDATED_ARCHIVED_PRODUCT_ID,
	VIEW_TECHPACK
} from '@store/searchOptions/action-types';

import { getUserPreference } from '@utils/Util';

const userPreference = getUserPreference();

const initialState = {
	isAddToFavourite: userPreference?.IS_ADD_TO_FAVOURITE || false,
	isViwTechpack: userPreference?.IS_VIEW_TECHPACK || false,
	isUpdateSampleId: userPreference?.IS_UPDATE_SAMPLE_ID || false,
	searchResult: null,
	searchType: userPreference?.SEARCH_TYPE || 'DESIGN_NO',
	isFocusOnModalClose: userPreference?.IS_FOCUS_ON_MODAL_CLOSE || false,
	isEditPresentation: userPreference?.IS_EDIT_PRESENTATION || false,
	isTechpackOpen: false,
	updatedArchivedProductId: null
};

const CollectionSearchOptionsReducers = (state = initialState, { type, payload }) => {
	switch (type) {
		case ADD_TO_FAVOURITE:
			return {
				...state,
				isAddToFavourite: payload
			};
		case VIEW_TECHPACK:
			return {
				...state,
				isViwTechpack: payload
			};
		case UPDATE_SAMPLE_ID:
			return {
				...state,
				isUpdateSampleId: payload
			};
		case GET_SEARCH_RESULT:
			return {
				...state,
				searchResult: payload
			};
		case SELECTED_SEARCH_TYPE:
			return {
				...state,
				searchType: payload
			};
		case REMOVE_SEARCH_RESULT:
			return {
				...state,
				searchResult: null
			};
		case IS_FOCUS_ON_MODAL_CLOSE:
			return {
				...state,
				isFocusOnModalClose: payload
			};
		case IS_TECHPACK_OPEN:
			return {
				...state,
				isTechpackOpen: payload
			};
		case IS_EDIT_PRESENTATION:
			return {
				...state,
				isEditPresentation: payload
			};
		case UPDATED_ARCHIVED_PRODUCT_ID:
			return {
				...state,
				updatedArchivedProductId: payload
			};
		default:
			return state;
	}
};

export default CollectionSearchOptionsReducers;
